import React from 'react';
import PropTypes from 'prop-types';
import CategoryToolTile from './CategoryToolTile';
import { find } from 'lodash';
import { HeadingText } from '@paypalcorp/pp-react';

const StaffPicks = props => {
  const {
    content = {},
    fptiImpression,
    fptiClick,
    toolTileProps,
    structuredPSData
  } = props;
  const { staffPickDisplayed = [] } = structuredPSData;
  const {
    flatPSData: { tools = {}, categories = {}, isNewLayoutEligible } = {}
  } = toolTileProps;

  const categoriesArr = Object.values(categories);

  const toolsArr = Object.values(tools);

  const handleClickTool = ({
    fptiLink,
    prod,
    PSUrl,
    categoryRank,
    appKey,
    rank,
    priorityScore
  }) => {
    return () => {
      fptiClick({
        fptiLink,
        prod,
        pageLink: content.categoryFPTI,
        categoryRank,
        appKey,
        rank,
        priorityScore
      });
      fetch(PSUrl);
    };
  };

  const getCategoryLayout = () => {
    if (isNewLayoutEligible) {
      return staffPickDisplayed.length < 4
        ? ' category-grid singleton'
        : 'category-grid';
    }
    return 'category-row';
  };

  return (
    <div id="appcenter-categories">
      <div
        className={
          isNewLayoutEligible ? 'appcenter-category new' : 'appcenter-category'
        }
      >
        <div
          className={
            isNewLayoutEligible ? 'category-header new' : 'category-header'
          }
        >
          <HeadingText level={2}>
            {isNewLayoutEligible
              ? content.categoryTitleVariant
              : content.categoryTitle}
          </HeadingText>
        </div>
        <div className={getCategoryLayout()}>
          {staffPickDisplayed.map(sortedTool => {
            const staffPickTool =
              find(toolsArr, obj => obj.appKey === sortedTool.appKey) || {};
            const staffPickCategory = find(
              categoriesArr,
              obj => obj.categoryKey === staffPickTool.categoryKey
            );
            if (staffPickCategory === undefined) {
              return null;
            }
            return (
              <CategoryToolTile
                fptiImpression={fptiImpression}
                tool={staffPickTool}
                toolTileProps={toolTileProps}
                path={`/appcenter/${staffPickCategory.location}`}
                handleClickTool={handleClickTool}
                hideFavorites={false}
                staffPickType="paypal_picks"
                pageLink={content.categoryFPTI}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

StaffPicks.propTypes = {
  content: PropTypes.object,
  structuredPSData: PropTypes.object,
  toolTileProps: PropTypes.object,
  fptiImpression: PropTypes.func,
  fptiClick: PropTypes.func
};

export default StaffPicks;
